import React, { useState, useEffect } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote, MessageCircle } from 'lucide-react';

const Testimonials = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isInView, setIsInView] = useState(false);

    // Real review data from your provided reviews
    const reviews = [
        {
            "id": 1,
            "name": "sarita choudhury",
            "text": "Great service.Availed dry cleaning .Timely delivery, no stains.. good job",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 2,
            "name": "Arbaz Shaik",
            "text": "Very professional and seamless service. I am really happy with their work and their clear communication.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 3,
            "name": "Chaitanya",
            "text": "Excellent and prompt service with reasonable prices.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 4,
            "name": "Shishir Bhargava",
            "text": "Great service and prompt responses to customer's queries. I will recommend their laundry services",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 5,
            "name": "Nikita",
            "text": "Sparkle Xxpress provides a reliable and high-quality laundry service. With competitive pricing and a range of additional services, I recommend it for those needing professional cleaning.Happy with their services.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 6,
            "name": "Tae koo",
            "text": "Overall, a good dry cleaning service providing high-quality cleaning, reliable and timely service, fair pricing, and excellent customer support",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 7,
            "name": "padmala ramesh",
            "text": "Home pickup/delivery and service is trouble free.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 8,
            "name": "Pavan Gaggala",
            "text": "Had a great experience with Sparkle Xxpress Laundry! On-time Pick up and delivery. The way clothes packed after dry cleaning and ironing was amazing. Keep up the good work.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 9,
            "name": "Sindhu Chowdary",
            "text": "Professional and Very Responsive at their work",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 10,
            "name": "Sindu Vegiraju",
            "text": "Very good service..Much impressed with the way they pack the clothes after ironing or dry clean...Neat and clean...Wil definitely recommend Sparkle laundry.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 11,
            "name": "haritha cheppalli",
            "text": "It's been almost a year I am using Sparkle laundry services.They are exceptional in service.Impressed with their prompt service.Kudos to the team.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 12,
            "name": "Viswesh Guruguntala",
            "text": "Have been using service for more than 6 months, and they have been prompt on service and delivering iron and dry clothes on time.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 13,
            "name": "Rajeshkumar Burrah",
            "text": "Good Service, Prompt Response on Queries.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 14,
            "name": "Pawan Kumar",
            "text": "Well managed and timely pick up and delivery at doorsteps. Good service 👍",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 15,
            "name": "Ramya Sri",
            "text": "Good service, easy pickup and delivery",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 16,
            "name": "Praveen Reddy Chinthireddy",
            "text": "Good service and timely delivery",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 17,
            "name": "Rajesh Bavirisetty",
            "text": "Good service and on time, free pickup and drop, I mostly used steam iron and very happy with the service",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 18,
            "name": "N.C. VARADARAJU",
            "text": "Prompt delivery,Nice Communication and Excellent behaviour.. We are impressed.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 19,
            "name": "Srivatsava Ravula",
            "text": "They are the best laundry service till date I came over, I usually go for cloth press and I am impressed with the steam iron and the way they pack the clothes after; I have no complaints so far. On top of all Free home pickup and drop is available.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 20,
            "name": "Ishitwa Deb",
            "text": "Good service and owner is very well mannered",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 21,
            "name": "shayani23 pendyala",
            "text": "Very good service and good work. I had given my white shoes for laundry as it got spoiled with dark oil. After laundry they became sparkling white !! Reasonable rates & most important is home pick up - drop which is amazing service with quick delivery. Thank you.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 22,
            "name": "Sahithi Chakka",
            "text": "Prompt delivery and nice pressing of clothes",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 23,
            "name": "Perumalla Sujatha",
            "text": "Really really a good service ,added glow to my memorable fav dress.tellapur people don't miss the opportunity for having a good looking ironing, steaming to your clothes.Far away people can check with the manager pankaj for delivery and get your clothes ready for the events.Very responsible with prompt replies.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 24,
            "name": "Yesh Wanth",
            "text": "Service is verg good and home delivery concept is very helpfulPositiveResponsiveness, Quality, Professionalism, Value",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 25,
            "name": "mulam pavan",
            "text": "Very happy with your services .you guys are delivered on time . Thanks for your service 🙏👍PositiveResponsiveness, Quality, Professionalism, Value",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 26,
            "name": "Amit Kumar",
            "text": "If you are looking for steam iron and you are in this Tellapur area this is the best option. Others are either too expensive or not professional.PositiveResponsiveness, Quality, Professionalism, Value",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 27,
            "name": "Divya Arora",
            "text": "On time delivery. Happy customer.PositiveResponsiveness, Quality, Professionalism",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 28,
            "name": "mounika yedapalli",
            "text": "Service is good...PositiveProfessionalism",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 29,
            "name": "Kali Charan",
            "text": "Amazing Laundry timely servicePositiveResponsiveness, Quality, Professionalism, Value",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 30,
            "name": "Swati Singh",
            "text": "PositiveResponsiveness, Quality, Professionalism, Value",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 31,
            "name": "jigyasa rangeen",
            "text": "They have been very responsive and always commit to correct timeline. Always displayed commitment to their business and provided good and honest service to the clients!PositiveResponsiveness, Quality, Professionalism, Value",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 32,
            "name": "Rated Nijam",
            "text": "PositiveResponsiveness, Quality, Professionalism, Value",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 33,
            "name": "Preeti Shorey",
            "text": "Service is really good. Nicely ironed and packed properly. Free pickup and delivery is really helpful. On time delivery.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 34,
            "name": "Poornima saxena",
            "text": "I got to know this from Telegram group and I tried it for first time. I am happy with their services and I recommend Sparkle Xxpress Laundry 🙂👍PositiveResponsiveness, Professionalism, Value",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 35,
            "name": "Avani Parekh",
            "text": "The clothes are ironed well, packed neatly and before time delivery. What more could you ask for. Thank you.PositiveResponsiveness, Quality, Professionalism",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 36,
            "name": "Dushyant Vyas",
            "text": "Good packaging and on time pickup and delivery!PositiveQuality",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 37,
            "name": "priya gupta",
            "text": "Great service, very responsive and professional. Free pickup and drop is icing on the cake. Would recommend strongly.",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 38,
            "name": "Mounika Rao",
            "text": "PositiveResponsiveness, Quality, Professionalism, Value",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 39,
            "name": "Nisha Kumari",
            "text": "Amazing services. Delivery was on time. Nicely ironed and packed properly. Definitely recommendable.PositiveResponsiveness, Professionalism, Value",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 40,
            "name": "Janani Reddy Gorusu",
            "text": "Ontime delivery!Hassle free Pick and drop.Responsible and professionalNice packing 👍🏼PositiveResponsiveness, Quality",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 41,
            "name": "Karthik Dasa",
            "text": "I used ironing services, they did it very professionally. Can go for it.PositiveProfessionalism",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 42,
            "name": "Shiva Swaroop",
            "text": "Free pickup and drop is convenient and they are responsive. Used their services for ironing and their quality, promptness, VFM and packaging were good. Especially the owner checked with us personally and took the feedback which is appreciated. Highly recommended in the area.PositiveResponsiveness, Quality, Professionalism",
            "rating": 5,
            "source": "Google"
        },
        {
            "id": 43,
            "name": "Maanvi P",
            "text": "Home delivery, nice quality- ironing with steam , timely delivery and quite responsive.. RecommendedPositiveQuality, Professionalism, Value",
            "rating": 5,
            "source": "Google"
        }
    ];

    // Generate a color based on name
    const getAvatarColor = (name) => {
        const colors = [
            'bg-blue-500', 'bg-green-500', 'bg-yellow-500',
            'bg-red-500', 'bg-purple-500', 'bg-pink-500',
            'bg-indigo-500', 'bg-teal-500', 'bg-orange-500',
            'bg-cyan-500', 'bg-lime-500', 'bg-violet-500'
        ];

        // Simple hash function to determine color
        const hash = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
        return colors[hash % colors.length];
    };

    // Get initials from name
    const getInitials = (name) => {
        return name.split(' ')
            .map(part => part[0])
            .join('')
            .toUpperCase();
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                }
            },
            { threshold: 0.1 }
        );

        const section = document.getElementById('testimonials');
        if (section) {
            observer.observe(section);
        }

        return () => {
            if (section) {
                observer.unobserve(section);
            }
        };
    }, []);

    useEffect(() => {
        if (isInView) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
            }, 5000);

            return () => clearInterval(interval);
        }
    }, [isInView, reviews.length]);

    const handlePrevious = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? reviews.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    };

    const goToReview = (index) => {
        setCurrentIndex(index);
    };

    // Display 3 reviews at a time on desktop, 1 on mobile
    const getVisibleReviews = () => {
        const visibleReviews = [];
        // Using window check with optional chaining for SSR compatibility
        const displayCount = typeof window !== 'undefined' && window?.innerWidth > 768 ? 3 : 1;

        for (let i = 0; i < displayCount; i++) {
            const index = (currentIndex + i) % reviews.length;
            visibleReviews.push(reviews[index]);
        }
        return visibleReviews;
    };

    const visibleReviews = getVisibleReviews();

    return (
        <section id="testimonials" className="py-16 md:py-24 bg-gray-50">
            <div className="container mx-auto px-4 sm:px-6 lg:px-12">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <span className="inline-block px-4 py-2 bg-orange-100 text-orange-700 rounded-full text-sm font-medium mb-4">Testimonials</span>
                    <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">What Our Customers Say</h2>
                    <div className="flex items-center justify-center mb-6">
                        <div className="flex">
                            {[...Array(5)].map((_, i) => (
                                <Star
                                    key={i}
                                    size={24}
                                    fill="#F59E0B"
                                    className="text-orange-500 mx-1"
                                />
                            ))}
                        </div>
                        <span className="ml-3 text-lg font-bold text-gray-700">4.9 out of 5 <span className="font-normal">({reviews.length} reviews)</span></span>
                    </div>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Discover why our customers love our services. Read real reviews from people who have experienced our professional laundry solutions.
                    </p>
                </div>

                {/* Reviews Section */}
                <div className="relative">
                    {/* Desktop Navigation Buttons */}
                    <div className="hidden md:block">
                        <button
                            onClick={handlePrevious}
                            className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-6 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center text-gray-800 hover:bg-orange-500 hover:text-white transition-all z-10"
                            aria-label="Previous review"
                        >
                            <ChevronLeft size={24} />
                        </button>
                        <button
                            onClick={handleNext}
                            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-6 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center text-gray-800 hover:bg-orange-500 hover:text-white transition-all z-10"
                            aria-label="Next review"
                        >
                            <ChevronRight size={24} />
                        </button>
                    </div>

                    {/* Reviews Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {visibleReviews.map((review, idx) => (
                            <div
                                key={`visible-${idx}`}
                                className="bg-white rounded-xl shadow-lg p-6 relative transition-all duration-300 hover:shadow-xl"
                            >
                                <div className="absolute -top-3 -right-3 bg-orange-500 rounded-full p-2 text-white">
                                    <MessageCircle size={18} />
                                </div>
                                <div className="flex items-center mb-4">
                                    <div className={`w-12 h-12 rounded-full mr-4 border-2 border-orange-200 flex items-center justify-center text-white font-bold ${getAvatarColor(review.name)}`}>
                                        {getInitials(review.name)}
                                    </div>
                                    <div className="text-left">
                                        <h4 className="font-bold text-gray-800 text-left">{review.name}</h4>
                                        <div className="flex items-center">
                                            <div className="flex">
                                                {[...Array(5)].map((_, i) => (
                                                    <Star
                                                        key={i}
                                                        size={14}
                                                        fill={i < review.rating ? "#F59E0B" : "#E5E7EB"}
                                                        className={i < review.rating ? "text-orange-500" : "text-gray-300"}
                                                    />
                                                ))}
                                            </div>
                                            <span className="ml-2 text-xs text-gray-500">{review.date}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-4">
                                    <div className="text-blue-700 mb-2">
                                        <Quote size={20} />
                                    </div>
                                    <p className="text-gray-600 italic">{review.text}</p>
                                </div>
                                <div className="flex items-center mt-4 pt-4 border-t border-gray-100">
                                    <div className="flex items-center">
                                        <img
                                            src="https://www.google.com/s2/favicons?sz=64&domain_url=google.com"
                                            alt="Google Review"
                                            className="w-5 h-5 mr-2"
                                        />
                                        <span className="text-sm text-gray-500">Verified {review.source} Review</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Mobile Navigation */}
                    <div className="flex justify-center mt-8 md:hidden">
                        <button
                            onClick={handlePrevious}
                            className="mx-2 w-10 h-10 rounded-full bg-white shadow flex items-center justify-center text-gray-800 hover:bg-orange-500 hover:text-white transition-all"
                        >
                            <ChevronLeft size={20} />
                        </button>
                        <div className="flex space-x-2 items-center">
                            {reviews.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => goToReview(index)}
                                    className={`w-2 h-2 rounded-full transition-all ${currentIndex === index
                                        ? 'bg-orange-500 w-4'
                                        : 'bg-gray-300 hover:bg-gray-400'
                                        }`}
                                    aria-label={`Go to review ${index + 1}`}
                                />
                            ))}
                        </div>
                        <button
                            onClick={handleNext}
                            className="mx-2 w-10 h-10 rounded-full bg-white shadow flex items-center justify-center text-gray-800 hover:bg-orange-500 hover:text-white transition-all"
                        >
                            <ChevronRight size={20} />
                        </button>
                    </div>
                </div>

                {/* View All Reviews Button */}
                <div className="text-center mt-12">
                    <a
                        href="https://g.page/sparklexxpresslaundry/review"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center px-6 py-3 bg-orange-500 text-white rounded-full font-medium hover:bg-blue-700 transition-colors"
                    >
                        Leave Us a Review
                        <ChevronRight size={20} className="ml-2" />
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;